import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { BrowserRouter, Route, Routes as RoutesDom } from "react-router-dom";

import { CssBaseline } from "@mui/material";
import InitColorSchemeScript from "@mui/material/InitColorSchemeScript";
import { ThemeProvider } from "@mui/material/styles";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import adminViews from "./components/admin/adminViews";
import AdminContainer from "./components/admin/views/AdminContainer";
import RedirectRoute from "./route/RedirectRoute";
import { theme } from "./theme/new-theme.tsx";

const App = React.lazy(() => import("./components/app/App"));

const OrgWrapper = React.lazy(() => import("./components/org/OrgWrapper"));
const Api = React.lazy(() => import("./components/api/Api"));
const Locales = React.lazy(
  () => import("./components/admin/views/locales/Locales")
);
const CreateAgreement = React.lazy(
  () => import("./components/admin/views/agreement/CreateAgreement")
);
const UpdateAgreement = React.lazy(
  () => import("./components/admin/views/agreement/UpdateAgreement")
);
const Dashboard = React.lazy(() => import("./components/dashboard/Dashboard"));
const User = React.lazy(() => import("./components/user/UserView"));

const Login = React.lazy(() => import("./components/login/Login"));
const LoginCallback = React.lazy(
  () => import("./components/login/LoginCallback")
);

const SalesInsight = React.lazy(
  () => import("./components/admin/views/sales/SalesInsight")
);

const MINUTE = 1000 * 60;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * MINUTE,
    },
  },
});

const Routes = () => (
  <QueryClientProvider client={queryClient}>
    <InitColorSchemeScript defaultMode="system" />
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline />
      <BrowserRouter basename="/">
        <RoutesDom>
          <Route element={<App />}>
            <Route element={<AdminContainer />}>
              {Object.keys(adminViews).map((view) => {
                const Component = adminViews[view];
                return <Route key={view} path={view} element={<Component />} />;
              })}
            </Route>
            <Route path="sales-insight" element={<SalesInsight />} />
            <Route path="org/:id" element={<OrgWrapper />} />
            <Route path="api/:id" element={<Api />} />
            <Route path="api/:id/newVersion" element={<Api />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="locales" element={<Locales />} />
            <Route path="create-agreement" element={<CreateAgreement />} />
            <Route path="agreement/:id" element={<UpdateAgreement />} />
            <Route path="user/:id" element={<User />} />
            <Route path="*" element={<RedirectRoute />} />
          </Route>
          <Route path="login" element={<Login />} />
          <Route path="login/callback" element={<LoginCallback />} />
        </RoutesDom>
      </BrowserRouter>
    </ThemeProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

export default Routes;
